import {getheaders} from "./authService";


export function uploadImage(url, file, onProgress) {
    return new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest();

        xhr.open('PUT', url);

        xhr.setRequestHeader('Content-Type', 'application/octet-stream');

        // Event listener for upload progress
        xhr.upload.onprogress = (event) => {
            if (event.lengthComputable) {
                const percentage = (event.loaded / event.total) * 100;
                onProgress(Math.round(percentage)); // Callback with the upload percentage
            }
        };

        // Event listener for request completed
        xhr.onload = () => {
            if (xhr.status >= 200 && xhr.status < 300) {
                resolve(xhr.response);
            } else {
                reject(new Error('Upload failed: ' + xhr.statusText));
            }
        };

        // Event listener for request error
        xhr.onerror = () => reject(new Error('Upload failed: ' + xhr.statusText));

        xhr.send(file);
    });
}

export function prepareUploadImage(title, imageType, cosJobId) {
    let reqBody = {
        title: title,
        image_type: imageType,
        cos_job_id: cosJobId
    }
    let requestOptions = {
        method: 'POST', headers: getheaders(), redirect: 'follow', body: JSON.stringify(reqBody)
    };
    return fetch("/api/images/upload", requestOptions)
}

export function populateImageUrl(cosJobId) {
    let requestOptions = {
        method: 'GET', headers: getheaders(), redirect: 'follow'
    };
    return fetch("/api/images/fetch/" + cosJobId, requestOptions)
}

export function removeImage(image) {
    let requestOptions = {
        method: 'PUT', headers: getheaders(), redirect: 'follow', body: JSON.stringify(image)
    };
    return fetch("/api/images/remove", requestOptions)
}

